<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <p>{{ message }}</p>
  <mat-form-field *ngIf="inputLabel">
    <input [(ngModel)]="inputValue" [placeholder]="inputLabel" matInput required />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="onCancel()" color="primary" mat-button tabindex="2">Cancel</button>
  <button (click)="onOk()" [color]="this.confirmationColor ?? 'primary'" mat-raised-button tabindex="1">
    {{ confirmationLabel ?? 'OK' }}
  </button>
</mat-dialog-actions>
